/**
 * Запомненият режим на терминала — `localStorage["edge_mode"] = { mode,
 * localSince, ip, port }` (§13.1 на договора, docs/edge.md §Студен старт).
 * Пише се при ВСЯКА смяна на режима (`edgeMode.ts`), чете се веднъж при
 * старт: кеширан `local` → една сонда `GET {edge}/health` и при `ok`
 * терминалът тръгва направо срещу касата, без трите сонди с хистерезис.
 *
 * `ip`/`port` са адресът на касата към момента на смяната — информативен
 * отпечатък; адресът, по който се сондира, остава този от кешираната
 * конфигурация (`edgeConfig.ts`), която е единственият източник на истина
 * за него. Чисти се при пълен изход (`lib/auth.ts` → `clearToken`).
 */
import {
  EDGE_MODE_STORAGE_KEY,
  edgeStorageGet,
  edgeStorageRemove,
  edgeStorageSet,
  type EdgeMode,
} from "./edgeState";

export interface CachedEdgeMode {
  mode: EdgeMode;
  /** От кога тече локалният режим (ISO от касата); null в облака. */
  localSince: string | null;
  ip: string | null;
  port: number;
}

export function readCachedEdgeMode(): CachedEdgeMode | null {
  const raw = edgeStorageGet(EDGE_MODE_STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<CachedEdgeMode>;
    if (!parsed || typeof parsed !== "object") return null;
    return {
      mode: parsed.mode === "local" ? "local" : "cloud",
      localSince:
        typeof parsed.localSince === "string" ? parsed.localSince : null,
      ip: typeof parsed.ip === "string" ? parsed.ip : null,
      port: typeof parsed.port === "number" ? parsed.port : 8787,
    };
  } catch {
    return null;
  }
}

export function writeCachedEdgeMode(cached: CachedEdgeMode) {
  edgeStorageSet(EDGE_MODE_STORAGE_KEY, JSON.stringify(cached));
}

export function clearCachedEdgeMode() {
  edgeStorageRemove(EDGE_MODE_STORAGE_KEY);
}
